module.exports = __webpack_public_path__ + "static/media/ContractClosure – Arabic@2x.f3868f52.jpg";